import { render } from "./treasureView.vue?vue&type=template&id=5516bcf9&scoped=true"
import script from "./treasureView.vue?vue&type=script&lang=js"
export * from "./treasureView.vue?vue&type=script&lang=js"

import "./treasureView.vue?vue&type=style&index=0&id=5516bcf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516bcf9"]])

export default __exports__